import { useMutation } from 'react-query';
import { successToast } from 'lib/components/toasts/success';
import { errorToast } from 'lib/components/toasts/error';
import { VideoTranscriptionBody } from '../types';
import { EXPRESS_API } from 'configs/api/expressApi';
import { useTranslation } from 'react-i18next';

type Props = {
  videoId: string;
  mediaBody: VideoTranscriptionBody;
};
const createTranscription = async (data: Props) => {
  const { videoId, mediaBody } = data;
  return (await EXPRESS_API.post(`/transcripts/${videoId}`, mediaBody)).data;
};
export const useVideoTranscriptionUpdate = () => {
  const { t } = useTranslation();
  return useMutation(
    async (data: Props) => {
      await createTranscription(data);
    },
    {
      onSuccess: () => {
        successToast({ title: t('Subtitles updated!') });
      },
      onError: (_, variables: Props) => {
        errorToast({
          title: variables.mediaBody.transcript
            ? t('Whoops! Error updating subtitles. Try again later!')
            : variables.mediaBody.enabled
              ? t('Whoops! Could not disable subtitles. Try again later!')
              : t('Whoops! Could not enable subtitles. Try again later!'),
        });
      },
    }
  );
};
